import script from "./LoginPlace.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginPlace.vue?vue&type=script&setup=true&lang=js"

import "./LoginPlace.vue?vue&type=style&index=0&id=6f0daf4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f0daf4c"]])

export default __exports__